import { render, staticRenderFns } from "./hangup-icon.vue?vue&type=template&id=d2902f52"
import script from "./hangup-icon.vue?vue&type=script&lang=js"
export * from "./hangup-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports